export default __webpack_public_path__ + "static/media/down.4caf577f.svg";